
import { Separator } from "@comps/ui/separator";
import { DashboardRightType, EditRightAccess, FullRightAccess, hasGlobalRightAccess, MembersRightType, ObjectRightType, ReadRightAccess, ViewRightType } from "@dto/Users";
import { getWsButtonStyle, TW_AppSidebar, TW_AppSidebarMenuContainer, TW_AppSidebarMenuIcon, TW_AppSidebarMenuText, useHover } from "@utils/twClasses";
import { ArrowLeft2, ArrowRight2, People } from "iconsax-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useModelStore, useUserStore } from "src/store";
import DashboardList from "./DashboardList";
import ObjectList from "./ObjectList";


const openWidth = " bg-gray-100 px-4 w-full min-w-12";
const closedWidth = " bg-gray-100 w-[2px]";

interface AppSidebarProps {
  onArrowclick: () => void;
  sideBarOpen: boolean;
  isMobile?: boolean;
  onMobileClose?: () => void;
}

function AppSidebar({ onArrowclick, sideBarOpen, isMobile = false, onMobileClose }: AppSidebarProps) {

  const workspace = useModelStore(state => state.selectedWorkspace);
  const objectInfos = useModelStore(state => state.objectInfos);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectObjectInfos = useModelStore(state => state.selectObjectInfos);
  const wsColor = useModelStore(state => state.wsColor);
  const wsLightColor = useModelStore(state => state.wsLightColor);
  const wsDarkColor = useModelStore(state => state.wsDarkColor);
  const wsHoverColor = useModelStore(state => state.wsHoverColor);
  const dashboards = useModelStore(state => state.dashboards);
  const membersHover = useHover(getWsButtonStyle('transparent'), getWsButtonStyle(wsHoverColor, wsColor))
  const userRole = useModelStore(state => state.userRole);
  const [sidebarButtonHover, setSidebarButtonHover] = useState(false);
  const user = useUserStore(state => state.user);
  
  const openMembers = () => {
    if (!workspace?._key) {
      console.error("Workspace key is not set");
      return;
    }
    
    // Always close mobile sidebar when clicked
    if (isMobile && onMobileClose) {
      onMobileClose();
    }
    
    navigate(`/workspaces/${workspace._key}/members`);
    selectObjectInfos(null, null, null);
  }

  const style = {
    scrollbarColor: wsColor + " " + wsLightColor,
    zIndex: 50
  }

  const hasObjectRight = hasGlobalRightAccess(user, userRole, ObjectRightType, ReadRightAccess);
  const hasFullObjectRight = hasGlobalRightAccess(user, userRole, ObjectRightType, FullRightAccess);
  const hasViewFullRight = hasGlobalRightAccess(user, userRole, ViewRightType, FullRightAccess);
  const hasDashboardRight = hasGlobalRightAccess(user, userRole, DashboardRightType, ReadRightAccess);
  const hasDashboardFullRight = hasGlobalRightAccess(user, userRole, DashboardRightType, FullRightAccess);
  const hasVisibleDashboards = (dashboards?.length ?? 0) > 0;
  const hasMembersRight = hasGlobalRightAccess(user, userRole, MembersRightType, EditRightAccess);

  const showObjectList = hasFullObjectRight || hasViewFullRight || objectInfos.some(objectInfo => objectInfo.views && objectInfo.views.length > 0 || hasGlobalRightAccess(user, userRole, ObjectRightType, FullRightAccess, objectInfo.object._key))
  const showDashboardSection = hasDashboardRight && (hasVisibleDashboards || hasDashboardFullRight)
  return (
    
    <div className={`${TW_AppSidebar} ${sideBarOpen ? openWidth : closedWidth} ${isMobile ? 'md:hidden' : ''}`} style={style}>
      {sideBarOpen
      ? <>
        {!isMobile && (
          <ArrowLeft2 width={16} height={40} color={wsDarkColor} className="cursor-pointer border-0 hover:border-1 rounded-sm border-gray-400 absolute top-[50%] right-0 hover:bg-white " style={{zIndex:50, borderColor: wsColor, width:"16px", height:"40px"}} onMouseEnter={()=>setSidebarButtonHover(true)} onMouseLeave={()=>setSidebarButtonHover(false)} onClick={onArrowclick}/>
        )}
        {workspace && showObjectList && hasObjectRight && <ObjectList {...(isMobile && onMobileClose ? { onMobileClose } : {})} />}
        {workspace && showObjectList && (showDashboardSection || hasMembersRight) && <Separator />}
        {workspace && !showObjectList && <div className="h-1 w-full" />}
        {workspace && showDashboardSection && <DashboardList {...(isMobile && onMobileClose ? { onMobileClose } : {})} /> }
        {workspace && hasMembersRight && <div onClick={openMembers} className={TW_AppSidebarMenuContainer} {...membersHover}><People className={TW_AppSidebarMenuIcon} /><p className={TW_AppSidebarMenuText}>{t("app.sidebar.button.members")}</p></div>}
        {!workspace && <p>{t("app.sidebar.no.workspace.selected")}</p>}
      </>
      : !isMobile && (
        <ArrowRight2 width={16} height={40} color={wsDarkColor} className="cursor-pointer border-0 hover:border-1 rounded-sm border-gray-400 bg-gray-100 absolute top-[50%] left-0 hover:bg-white " style={{zIndex:50, borderColor: wsColor, width:"16px", height:"40px"}} onMouseEnter={()=>setSidebarButtonHover(true)} onMouseLeave={()=>setSidebarButtonHover(false)} onClick={onArrowclick}/>
      )}
      
    </div>
  )
};

export default AppSidebar;